<template>
  <nav v-if="breadcrumbs && breadcrumbs.length > 1" aria-label="breadcrumb">
    <ol class="fk-breadcrumb flex flex-wrap gap-[.5em] text-xs mb-2">
      <li
        v-for="(breadcrumb, idx) in breadcrumbs"
        :key="`breadcrumb-${breadcrumb.collection}-${breadcrumb.slug}-${idx}`"
        :class="{ active: idx == breadcrumbs.length - 1 }"
        :aria-current="idx == breadcrumbs.length - 1 ? 'page' : 'false'"
        class="group flex items-center gap-[.5em]"
      >
        <svg
          v-if="idx > 0"
          xmlns="http://www.w3.org/2000/svg"
          height=".7em"
          class="fill-current"
          viewBox="0 0 320 512"
        >
          <path
            d="M301.3 256l-22.6 22.6-160 160L96 461.3 50.7 416l22.6-22.6L210.7 256 73.4 118.6 50.7 96 96 50.7l22.6 22.6 160 160L301.3 256z"
          />
        </svg>
        <NuxtLink
          :to="breadcrumb.to"
          class="hover:underline group-last:!no-underline group-last:cursor-default"
        >
          {{ breadcrumb.label }}
        </NuxtLink>
      </li>
    </ol>
  </nav>
</template>

<script setup lang="ts">
const { breadcrumbsKey } = useInjectionKeys();
const breadcrumbs = inject(breadcrumbsKey);
</script>
